module.exports = __webpack_public_path__ + "static/makook-designcode-994589a2a13519105b350dc4b27ccea2.jpg";